import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { useMemo } from "react";
import { useAuth } from "../auth/useAuth";
import { paths } from "../generated-types";

type NodeUrlsOperation = paths["/dashboard/synota/get-node-urls"]["get"];
type UseNodeUrlsResponse = NodeUrlsOperation["responses"][200]["content"]["application/json"];

export const useNodeUrls = () => {
  const { client } = useHttp();
  const { isAdmin } = useAuth();

  const { status, isPending, isFetching, isLoading, data, error, refetch } =
    useAxiosQuery<UseNodeUrlsResponse>({
      queryKey: ["get-node-urls"],
      queryFn: ({ signal }) => client.get("/synota/get-node-urls", { signal }),
      enabled: Boolean(isAdmin),
    });

  const nodeUrls = useMemo(() => {
    if (!data) {
      return [];
    }
    return data.data;
  }, [data]);

  return {
    nodeUrls,
    error,
    isLoading,
    isFetching,
    isPending,
    status,
    refetch,
  };
};

export type UseNodeUrlsReturn = ReturnType<typeof useNodeUrls>;
